import React from 'react';

import moment from 'moment';
import 'moment/locale/es';
import { Checkbox, Button } from 'antd/lib';
import { Form } from '@ant-design/compatible';

// import SelectorModelo from './SelectorModelo'
const FormItem = Form.Item;

moment.locale();

class FormAntecedentesViolencia extends React.Component {
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let valor = this.evaluarPuntaje(values);

        let respuestas = {
          ...values,
          valor,
        };

        // console.log(this.props);
        this.props.onSubmit(respuestas);
      }
    });
  };

  evaluarPuntaje = respuestas => {
    // console.log("Entre a evaluar el puntaje con....");
    // console.log(respuestas);

    let valor = 0;
    //Lo que busco a continuacion es sumar los valores, pero como estan en STRINGS, primero debo aplicar el operador UNARIO + para convertirlos a INT.

    if (respuestas.antecedenteViolenciaFisicaVictima) {
      valor = valor + 2;
    }

    if (respuestas.antecedenteViolacionVictima) {
      valor = valor + 4;
    }

    if (respuestas.antecedenteTestigoVictima) {
      valor = valor + 3;
    }

    if (respuestas.antecedenteAbandonoVictima) {
      valor = valor + 1;
    }

    if (respuestas.antecedenteViolenciaParejasPreviasVictima) {
      valor = valor + 2;
    }

    //CLASIFICACION DEL AGRESOR

    if (respuestas.antecedenteViolenciaFisicaAgresor) {
      valor = valor + 2;
    }

    if (respuestas.antecedenteViolacionAgresor) {
      valor = valor + 3;
    }

    if (respuestas.antecedenteTestigoAgresor) {
      valor = valor + 3;
    }

    if (respuestas.antecedenteAbandonoAgresor) {
      valor = valor + 2;
    }

    if (respuestas.antecedenteViolenciaParejasPreviasAgresor) {
      valor = valor + 2;
    }

    // console.log("El resultado es.... ", valor);

    return valor;
  };

  render() {
    moment.locale();
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <div>
        <h1 className="tituloForm">Evaluación de Antecedentes de Violencia</h1>

        <Form onSubmit={this.handleSubmit} className="formulariosViolencia">
          {' '}
          <h3> Antecedentes en la Victima: </h3>
          <FormItem {...formItemLayout} label="Violencia fisica o psicologica">
            {getFieldDecorator('antecedenteViolenciaFisicaVictima', {
              initialValue: false,
            })(<Checkbox />)}
          </FormItem>
          <FormItem {...formItemLayout} label="Violación o abuso sexual">
            {getFieldDecorator('antecedenteViolacionVictima', {
              initialValue: false,
            })(<Checkbox />)}
          </FormItem>
          <FormItem {...formItemLayout} label="Testigo de violencia">
            {getFieldDecorator('antecedenteTestigoVictima', {
              initialValue: false,
            })(<Checkbox />)}
          </FormItem>
          <FormItem {...formItemLayout} label="Abandono previo">
            {getFieldDecorator('antecedenteAbandonoVictima', {
              initialValue: false,
            })(<Checkbox />)}
          </FormItem>
          <FormItem {...formItemLayout} label="Violencia en otras parejas">
            {getFieldDecorator('antecedenteViolenciaParejasPreviasVictima', {
              initialValue: false,
            })(<Checkbox />)}
          </FormItem>
          <h3> Antecedentes en el Agresor: </h3>
          <FormItem {...formItemLayout} label="Violencia fisica o psicologica">
            {getFieldDecorator('antecedenteViolenciaFisicaAgresor', {
              initialValue: false,
            })(<Checkbox />)}
          </FormItem>
          <FormItem {...formItemLayout} label="Violación o abuso sexual">
            {getFieldDecorator('antecedenteViolacionAgresor', {
              initialValue: false,
            })(<Checkbox />)}
          </FormItem>
          <FormItem {...formItemLayout} label="Testigo de violencia">
            {getFieldDecorator('antecedenteTestigoAgresor', {
              initialValue: false,
            })(<Checkbox />)}
          </FormItem>
          <FormItem {...formItemLayout} label="Abandono previo">
            {getFieldDecorator('antecedenteAbandonoAgresor', {
              initialValue: false,
            })(<Checkbox />)}
          </FormItem>
          <FormItem {...formItemLayout} label="Violencia en otras parejas">
            {getFieldDecorator('antecedenteViolenciaParejasPreviasAgresor', {
              initialValue: false,
            })(<Checkbox />)}
          </FormItem>
          <FormItem {...tailFormItemLayout}>
            <Button style={{ margin: 10 }} type="primary" htmlType="submit">
              Siguiente
            </Button>
            <Button
              style={{ margin: 10 }}
              type="danger"
              onClick={this.props.onCancel}
            >
              Cancelar
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create()(FormAntecedentesViolencia);
